export default __webpack_public_path__ + "static/media/vizyon-logo-tagline-1.485d5ef9.png";